// Analytics is used to track the user's interactions with the app.
import { UNLOCK_SCENE, SELECT_CHOICE, SET_INVENTORY_ITEMS, CHANGE_SETTINGS, OPEN_QUEST, CLOSE_QUEST, SELECT_CHAPTER, EVENT_GENERAL_CUSTOM } from './constants'

// Re-export constants for convenience
export { UNLOCK_SCENE, SELECT_CHOICE, SET_INVENTORY_ITEMS, CHANGE_SETTINGS, OPEN_QUEST, CLOSE_QUEST, SELECT_CHAPTER }

const track = (param1: string, param2: string, param3?: string) => {
  if (window.DP && window.DP.analytics && window.dpAnalytics) {
    try {
      const DP = window.DP as {
        analytics?: {
          EventBuilder: new () => {
            setEventName: (name: string) => {
              setCustom: (
                param1: string,
                param2: string,
                param3: string | undefined,
              ) => {
                setInteraction: (interaction: boolean) => unknown
              }
            }
          }
        }
      }
      const dpAnalytics = window.dpAnalytics as {
        trackEvent?: (event: unknown) => void
      }
      if (DP.analytics && dpAnalytics.trackEvent) {
        const eventBuilder = new DP.analytics.EventBuilder()
          .setEventName(EVENT_GENERAL_CUSTOM)
          .setCustom(param1, param2, param3)
          .setInteraction(true)
        dpAnalytics.trackEvent(eventBuilder)
      }
    } catch (exception) {
      console.error(exception)
    }
  }
}

export default track
